<div class="department-page">
  <div class="department-header">
    <app-header-style-seven></app-header-style-seven>
  </div>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Shaping competent mechanical engineers through quality technical education,
            research exposure, industry collaboration, innovation, and ethical professional practice.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Affiliation</span>
            <strong>Anna University</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Mechanical Engineering, Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title11.jpg"
                  alt="Department of Mechanical Engineering"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>Broad career and professional outcomes expected from the programme.</p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>Knowledge, skills, and professional capabilities expected from graduates.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>Department-specific competencies developed through the programme.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Labs -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Practice-oriented labs supporting design, manufacturing, thermal,
                  materials, and automation learning in Mechanical Engineering.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let lab of labs">
                  <div class="lab-media">
                    <img [src]="lab.image" [alt]="lab.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ lab.title }}</h4>
                    <p>{{ lab.description }}</p>

                    <div class="equipment-note" *ngIf="lab.equipment">
                      <strong>Equipment:</strong> {{ lab.equipment }}
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Association Activities -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>Association Activities</h3>
                <p>
                  The department regularly organizes guest lectures, seminars, workshops,
                  and innovation-focused activities to strengthen students’ technical
                  knowledge, practical skills, and industry readiness.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S. No</th>
                      <th>Name of the Event</th>
                      <th>Date of Event</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of associationActivities">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.activity }}</td>
                      <td>{{ item.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let item of associationActivityPhotos">
                  <div class="lab-media">
                    <img [src]="item.image" [alt]="item.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- MOUs -->
    <ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU's</h3>
      <p>
        Our Mechanical Engineering department has signed MoUs to promote awareness
        and provide incubation opportunities for students and faculty. These
        collaborations help develop innovative startup products, extract knowledge
        from industry, gain exposure to the latest technologies, and foster
        entrepreneurship, industry-academia collaboration, and practical learning experiences.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S. No.</th>
            <th>MoU Company</th>
            <th>Description</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of mous">
            <td>{{ item.sno }}</td>
            <td>{{ item.company }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="activity-gallery" *ngIf="mouPhotos.length > 0">
      <div class="gallery-grid single-photo">
        <div class="gallery-card" *ngFor="let photo of mouPhotos">
          <img [src]="photo.image" [alt]="photo.alt" />
          <p *ngIf="photo.note">{{ photo.note }}</p>
        </div>
      </div>
    </div>
  </section>
</ng-container>

          <!-- Placement -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card">
              <div class="section-head">
                <h3>Placement Record 2025 - 2026</h3>
                <p>Recent student placements under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Student Name</th>
                      <th>Designation</th>
                      <th>Company</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of placementRecords">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.studentName }}</td>
                      <td>{{ item.designation }}</td>
                      <td>{{ item.company }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Industrial Visit -->
          <ng-container *ngSwitchCase="'tab9'">
            <section class="content-card">
              <div class="section-head">
                <h3>Industrial Visit</h3>
                <p>
                  The Mechanical Engineering Department organizes industrial visits to give students
                  practical exposure to real-time processes, machinery, and manufacturing techniques,
                  helping them apply classroom knowledge, gain industry insights, and prepare for
                  engineering careers.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Organization / Place</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of industrialVisitTable">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.organization }}</td>
                      <td>{{ item.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let visit of industrialVisits">
                  <div class="lab-media">
                    <img [src]="visit.image" [alt]="visit.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ visit.title }}</h4>
                    <p>{{ visit.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Research Centre -->
<ng-container *ngSwitchCase="'tab10'">
  <section class="content-card">
    <div class="section-head">
      <h3>Research Centre</h3>
      <p>Anna University recognized supervisors under the department research centre.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Supervisor Reference No.</th>
            <th>Supervisor Name</th>
            <th>Department</th>
            <th>Designation</th>
            <th>Specialization</th>
            <th>Contact Number</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let supervisor of supervisors">
            <td>{{ supervisor.sno }}</td>
            <td>{{ supervisor.referenceNo }}</td>
            <td>{{ supervisor.name }}</td>
            <td>{{ supervisor.department }}</td>
            <td>{{ supervisor.designation }}</td>
            <td>{{ supervisor.specialization }}</td>
            <td>{{ supervisor.contactNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Research Certificate</h3>
      <p>Recognized research centre certification reference.</p>
    </div>

    <div class="banner-image">
      <img [src]="researchCertificateImage" alt="Research Certificate" />
    </div>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Publications</h3>
      <p>
        Research publications contributed by faculty members in journals and conferences.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name of the Journal / Conference</th>
            <th>Title of the Paper</th>
            <th>Name of Author</th>
            <th>SCI / SCOPUS</th>
            <th>Year of Publication</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of publications">
            <td>{{ item.sno }}</td>
            <td>{{ item.journal }}</td>
            <td>{{ item.paperTitle }}</td>
            <td>{{ item.authorName }}</td>
            <td>{{ item.indexing }}</td>
            <td>{{ item.year }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Value Added Courses -->
          <ng-container *ngSwitchCase="'tab11'">
            <section class="content-card">
              <div class="section-head">
                <h3>Value Added Courses</h3>
                <p>Department-level additional learning opportunities for skill enhancement.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Course Name</th>
                      <th>Course Details</th>
                      <th>Commence Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of valueAddedCourses">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.courseName }}</td>
                      <td>{{ item.courseDetails }}</td>
                      <td>{{ item.commenceDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Alumni -->
<!-- Alumni -->
<ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Alumni</h3>
      <p>
        Distinguished alumni of the Department of Mechanical Engineering.
      </p>
    </div>

    <div class="lab-grid">
      <article class="lab-card" *ngFor="let alumni of alumniRecords">
        <div class="lab-media">
          <img [src]="alumni.image" [alt]="alumni.alt" />
        </div>

        <div class="lab-body">
          <h4>{{ alumni.name }}</h4>
          <p><strong>Batch:</strong> {{ alumni.batch }}</p>
          <p><strong>Designation:</strong> {{ alumni.designation }}</p>
          <p><strong>Organization:</strong> {{ alumni.organization }}</p>
          <p *ngIf="alumni.location">
            <strong>Location / Sector:</strong> {{ alumni.location }}
          </p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Achievements -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>Achievements</h3>
                <p>
                  Students of the Mechanical Engineering Department actively participate in
                  symposiums and technical events, securing prizes and recognition in
                  various competitions.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Student Name</th>
                      <th>Details</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of achievements">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.studentName }}</td>
                      <td>{{ item.details }}</td>
                      <td>{{ item.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab15'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>
                  Faculty members of the department have successfully completed NPTEL
                  courses and earned recognition for their performance.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Staff Name</th>
                      <th>Details</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of nptelRecords">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.staffName }}</td>
                      <td>{{ item.details }}</td>
                      <td>{{ item.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <br />

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Mechanical Engineering,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:mechhod@fmcet.ac.in">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Mechanical Engineering</h3>
        <p>Become a mechanical engineer and build a strong career in design, production, and innovation.</p>
<a
  routerLink="/inquiry"
  class="apply-button"
>
  Apply Now
</a>
      </article>
    </section>
  </div>
</div>